<ag-grid-angular
  class="ag-theme-quartz"
  [rowData]="rowData"
  [defaultColDef]="defaultColDef"
  [rowSelection]="defaultRowSelection"
  [pinnedTopRowData]="pinnedTopRowData"
  [gridOptions]="gridOptions"
  (gridReady)="gridReady($event)"
  (cellKeyDown)="onKeyDown($event)"
  (cellFocused)="onCellFocused($event)"
  (cellEditingStopped)="onCellEditingStopped($event)"
  domLayout="autoHeight"
/>
